"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOfficeApiResponseSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
exports.updateOfficeApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('offices'),
        attributes: zod_1.z.object({
            name: zod_1.z.string(),
            nationalMedicalOrderMail: zod_1.z.string(),
            address: address_schema_1.addressSchema,
            estimatedCaPerSlot: zod_1.z.coerce.number(),
            averageSlotHonorary: zod_1.z.coerce.number(),
            withAssistantRetrocessionRate: zod_1.z.coerce.number().min(0).max(1),
            withoutAssistantRetrocessionRate: zod_1.z.coerce.number().min(0).max(1),
            weekendRetrocessionRate: zod_1.z.coerce.number().min(0).max(1),
        }),
    }),
});
